export default __webpack_public_path__ + "static/media/video4.02d418ff.mp4";